enum events {
  TEXT_VARIATION_GENERATE = 'content-ai-variations-generate',
  TEXT_VARIATION_SHOW = 'content-ai-variations-show',
  TEXT_GENERATED = 'content-ai-generated-content',
  TEXT_QUICK_ACTION = 'content-ai-quick-action',
  IMAGE_GENERATE = 'image-ai-generate',
  IMAGE_VARIATION_SHOW = 'image-ai-variations-show',
  IMAGE_GENERATED = 'content-ai-generated-image',
}

export default events